import React from "react";
import { useParams } from "react-router-dom";
import { usePermissionGuardRedirect } from "../../../hooks/usePermissionGuard";
import LibraryDetails from "./LibraryDetails";
import LibraryList from "./LibraryList";

function LibraryTab({setBorrowerName}) {
  const { tab, type, id, editType } = useParams();

  usePermissionGuardRedirect(['slibraryborrowersview']);

  return (
    <div>
      {type && type == "table" && !id && <LibraryList />}
      {type && type == "detail" && id && <LibraryDetails setBorrowerName={setBorrowerName} />}      
    </div>
  );
}

export default LibraryTab;
